import { styled } from '@compiled/react';
import { Link } from '@helpcenter/analytics-components/src/link';
import { token } from '@atlaskit/tokens';

export const SEARCH_BAR_HEIGHT = token('space.1000', '80px');

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const ResultList = styled.ul({
    listStyleType: 'none',
    padding: 0,
});

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const Img = styled.img({
    width: token('space.1000', '80px'),
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/expand-spacing-shorthand
    padding: token('space.200', '16px'),
});

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const InlineResultsHeadingWrapper = styled.div({
    paddingLeft: token('space.200', '16px'),
});

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const InlineResultLink = styled(Link)({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    color: `${token('color.text', '#091E42')} !important`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    textDecoration: 'none !important',
    alignItems: 'center',
    paddingBlock: token('space.075', '6px'),
    paddingInline: token('space.200', '16px'),
    gap: token('space.150', '12px'),
    boxSizing: 'border-box',
    cursor: 'pointer',
    overflow: 'hidden',

    '&:hover': {
        backgroundColor: token('color.background.neutral.subtle.hovered', '#091e4214'),
    },

    '&:active': {
        backgroundColor: token('color.background.neutral.subtle.pressed', '#091E4224'),
    },

    '&:focus': {
        outlineStyle: 'solid',
        outlineWidth: token('border.width.focused', '2px'),
        outlineColor: token('color.border.focused', '#6495ed'),
    },
});

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const DropdownOptionList = styled.ul({
    listStyleType: 'none',
    padding: 0,
    marginBlockStart: token('space.100', '8px'),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    li: {
        marginTop: 0,
    },
});
